<template>
  <b-container class="ebook text-black my-5 p-5">
    <div class="w-100 text-center">
      <h2 class="display-4 text-black upper bold">Choisir une solution
      <br><span class="text-blue">adaptée à vos besoins</span></h2>
    </div>
  
    <b-row class="">
      <b-col cols="12" lg="5" class="d-flex justify-content-center">
        <b-card class="py-2 text-center">
          <b-card-img 
            title="Téléchargez le guide!"
            src="@/assets/images/7_criteres.svg" 
            img-alt="KLIX: Téléchargez le guide Les 7 critères de sélection d'une solution de GED"
            img-top
            tag="ebook"
            class="ebook-img mb-3" 
          ></b-card-img>
        
          
          <b-card-text>
            <strong>Les 7 critères de sélection pour bien choisir votre solution de Gestion Électronique de Documents</strong>
          </b-card-text>

          <b-button 
            class="ebook-cta stretched-link upper mt-3 p-3 w-100" 
            @click="showTheFormFirst"
            v-if="!showForm"
          >Téléchargez le guide</b-button>
        </b-card>
      </b-col>

      <b-col cols="12" lg="7" class="mt-4 text-left">
        <transition name="switch" mode="out-in">
          <div v-if="!this.showForm" >
            <p>Avant de finaliser votre choix de logiciel en gestion électronique de documents, 
              prenez le temps de réfléchir aux besoins de votre entreprise en matière de gestion 
              documentaire: </p>
              
            <p>Votre organisation se démarque des autres et devrait acquérir une 
              solution GED adaptée à sa situation et à ses enjeux commerciaux. Une fois que vous 
              aurez une meilleure idée de ce que vous recherchez, vous pourrez identifier les 
              fonctionnalités de la GED qui vous seront réellement utiles.</p>

            <p>Pour recevoir plus de conseils sur le choix d’un logiciel GED, téléchargez 
              gratuitement notre guide rédigé par les experts de KLIX.</p>
              
            <p>Pour être guidé dans vos démarches, vous pouvez également bénéficier d’une consultation 
              gratuite avec un de nos spécialistes en GED.</p>
          </div>
          
          <b-form 
            v-if="this.showForm" 
            @submit.prevent="submitEbookForm" 
          >
            <div v-if="!loading && !message.show">

              <b-form-group id="nameGroup" label="Nom:" label-for="name">
                <b-form-input
                  id="name"
                  type="text"
                  v-model="form.fullName"
                  placeholder="Entrez votre nom complet..."
                  :formatter="nameFormatter"
                  :state="nameValidation"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group id="entrepriseGroup" label="Entreprise:" label-for="entreprise">
                <b-form-input
                  id="entreprise"
                  type="text"
                  v-model="form.entreprise"
                  placeholder="Entrez le nom votre entreprise..." 
                  :formatter="nameFormatter"
                  :state="bizValidation"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="emailGroup" label="Courriel:" label-for="email">
                <b-form-input
                  id="email"
                  type="email"
                  v-model="form.email"
                  placeholder="Entrez votre courriel..." 
                  :formatter="emailFormatter"
                  :state="emailValidation"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="urlGroup" label="Site web:" label-for="url">
                <b-form-input
                  id="url"
                  type="text"
                  v-model="form.url"
                  placeholder="Entrez l'adresse du site web de votre entreprise..." 
                  :formatter="urlFormatter"
                  :state="urlValidation"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="jobGroup" label="Fonction dans l'entreprise:" label-for="job">
                <b-form-select id="job" v-model="form.job" :options="jobs"></b-form-select>
              </b-form-group>

              <b-form-group v-if="form.job === null" id="jobDetailsGroup" label="Spécifiez:" label-for="jobDetails">
                <b-form-input
                  id="jobDetails"
                  type="text"
                  v-model="form.job"
                  placeholder="Dites-nous quelle est votre fonction dans l'entreprise..." 
                  :formatter="textFormatter"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="dptGroup" label="Département:" label-for="dpt">
                <b-form-select id="dpt" v-model="form.dpt" :options="dpts"></b-form-select>
              </b-form-group>

              <b-form-group v-if="form.dpt === null" id="dptDetailsGroup" label="Spécifiez:" label-for="dptDetails">
                <b-form-input
                  id="dptDetails"
                  type="text"
                  v-model="form.dpt"
                  placeholder="Dites-nous dans quel département vous travaillez..." 
                ></b-form-input>
              </b-form-group>
            </div>

            <b-button 
              v-if="!loading && !message.show"
              type="submit" 
              variant="info"
              class="ebook-cta mt-3 p-3 w-100"
              :disabled="invalidForm"
            >
              <font-awesome-icon icon="cloud-download-alt" size="lg" class="mr-2"/>Téléchargez le guide
            </b-button>

            <b-alert 
              :variant="message.variant" 
              dismissible 
              :show="message.show"
              class="p-5"
              @dismissed="reset"
            >
              <h2 v-if="message.title">{{ message.title }}</h2>
              <p v-if="message.text">{{ message.text }}</p>
            </b-alert>

            <div v-if="loading" class="d-flex justify-content-center mb-3">
              <b-spinner label="Envoi..." ></b-spinner>
            </div>

          </b-form>
        </transition>
      </b-col>

    </b-row>
  </b-container>  
</template>

<script>
import axios from 'axios'

export default {
  name: 'Ebook',
  data() {
    return {
      base: process.env.BASE_URL,
      loading: false,
      showForm: false,
      ebook: '7-criteres-de-selection-ged.pdf',
      message: {
        show: false,
        content: null,
        style: `success`
      },
      form: {
        campain: `7-criteres`,
        fullName: null,
        email: null,
        phone: null,
        entreprise: null,
        url: null,
        dpt: 0,
        job: 0,
        more: {
          dpt: null,
          job: null
        }
      },
      jobs: [
        {
          value: 0,
          text: `Sélectionnez...`, 
          disabled: true
        },
        {
          value: 1,
          text: `Président - Présidente`
        },
        {
          value: 2,
          text: `Directeur - Directrice`
        },
        {
          value: 3,
          text: `Gestionnaire`
        },
        {
          value: 4,
          text: `Adjoint - Adjointe`
        },
        {
          value: null,
          text: `Autre`
        },
      ],
      dpts: [
        {
          value: 0,
          text: `Sélectionnez...`, 
          disabled: true
        },
        {
          value: 1,
          text: `Direction`
        },
        {
          value: 2,
          text: `Technologies de l'information (TI)`
        },
        {
          value: 3,
          text: `Ressorces Humaines`
        },
        {
          value: 4,
          text: `Comptes Fournisseurs`
        },
        {
          value: 5,
          text: `Comptes Clients`
        },
        {
          value: 6,
          text: `Opérations`
        },
        {
          value: 7,
          text: `Production`
        },
        {
          value: 8,
          text: `Services à la clientèle`
        },
        {
          value: null,
          text: `Autre`
        },
      ]
    }
  },
  computed: {    
    urlValidation() {
        let pattern =/^[A-z0-9-_\.:/]{2,150}\.[A-z0-9]{2,6}$/

        if (this.form.url) return this.runTest(this.form.url, pattern)
    },
    nameValidation() {
        let pattern =/^['A-z-\s\u00C0-\u017F]*$/
        
        if (this.form.fullName) return this.runTest(this.form.fullName, pattern)
    },
    bizValidation() {
        let pattern =/^['A-z-\s\u00C0-\u017F]*$/
        
        if (this.form.entreprise) return this.runTest(this.form.entreprise, pattern)
    },
    emailValidation() {
        let pattern =/^[\da-z\.-_]{2,150}@[\da-z\.-_]{2,150}\.([\da-z]{2,5})$/
        
        if (this.form.email) return this.runTest(this.form.email, pattern)
    },
    invalidForm() {
      if (
        (this.nameValidation && this.nameValidation !== null) &&
        (this.emailValidation && this.emailValidation !== null)
      ) {
        return false
      }
      
      return true
    }
  },
  methods: {
    submitEbookForm() {
      this.loading = true
          
      axios.post(this.base + '/api/campain', this.form)
          .then(response => {
              this.loading = false
              this.message = {
                  title: `Merci! Bonne lecture.`,
                  text: `N'hésitez pas à nous contacter si vous souhaitez faire part de votre projet de transition numérique avec une de nos personnes-ressources.`,
                  show: true,
                  variant: `success`
              }
              this.downloadEbook()
          })
          .catch(e => {
              this.message = {
                  text: `Une difficulté s'est produite durant l'enregistrement. Veuillez réessayer plus tard.`,
                  show: true,
                  variant: `danger`
              }
              this.loading = false
              
              console.log(e)
          })

      return false
    },
    downloadEbook(){
      axios.post(this.base + '/api/ebook', {ebook: this.ebook}, {responseType: 'arraybuffer'})
        .then(response => {      
          this.forceFileDownload(response.data);
        })
        .catch(e => {
          console.log(e)
        })
    },
    forceFileDownload(data){
      let blob = new Blob([data], { type: 'application/pdf' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Klix - votre ebook.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link);
    },
    runTest(field, pattern) {        
      if (field !== ``) {
          return pattern.test(field)
      }

      return null
    },
    urlFormatter(string) {
      return string.replace(/[^0-9A-z\.-_/:]/g, '').toLowerCase()
    },
    textFormatter(string) {
      return string.replace(/[^\sA-z\u00C0-\u017F-/:]/g, '')
    },
    phoneFormatter(string) {
      string = string
        .replace(/[^\d]/g, "")
        .replace(/^1/, "")
        .substring(0, 10);
      return (
        "(" +
        string.substring(0, 3) +
        ") " +
        string.substring(3, 6) +
        "-" +
        string.substring(6, 10)
      )
    },
    emailFormatter(string) {
        return string.toLowerCase()
    },
    nameFormatter(string) {
      let parts = [];

      if(string) {
        parts = string.split(" ");

        let nbParts = parts.length;

        if (nbParts > 1) {
          for (let p in parts) {
            if (typeof parts[p] === "string") {
              parts[p] = this.nameCapitalizer(parts[p])
            }
          }
          return parts.join(" ");
        } else {
          return this.nameCapitalizer(string)
        }
      }
    },
    nameCapitalizer(string) {
      let parts = [];

      parts = string.split("-");

      let nbParts = parts.length;

      if (nbParts > 1) {
        for (let p in parts) {
          if (typeof parts[p] === "string") {
            parts[p] = parts[p].replace(/[^'\sA-Za-z\u00C0-\u017F]/g, "");
            parts[p] =
              parts[p].substring(0, 1).toUpperCase() +
              parts[p].substring(1, parts[p].length).toLowerCase();
          }
        }
        return parts.join("-");
      } else {
        parts[0] = parts[0].replace(/[^'\sA-z\u00C0-\u017F-]/g, "");
        parts[0] =
          parts[0].substring(0, 1).toUpperCase() +
          parts[0].substring(1, parts[0].length).toLowerCase();

        return parts[0];
      }
    },
    showTheFormFirst() {
      this.showForm = !this.showForm
    },
    onReset(evt) {
      evt.preventDefault()
      reset()
    },
    reset() {
      this.msg = {
        show: false,
        text: ``,
        variant: `success`
      }

      this.form = {
        fullName: ``,
        email: ``,
        entreprise: ``,
        url: ``,
        dpt: ``,
        job: ``
      }

      this.showForm = false
      this.loading = false
      this.allowDownload = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ebook {
  position: relative;
  color: #fff;
}

.card {
  background-color: transparent;
  width: 80%;
  border: none;
  border-radius: 0;
  transition-duration: 0.2s;
}

.card-text {
  color: #000;
}

.ebook-img {
  width: 80%;
  min-width: 200px;
  max-width: 50vw;
  height: auto;
}

.switch-enter-active, .switch-leave-active {
  transition: all .3s ease;
}
.switch-enter, .switch-leave-to {
  opacity: 0;
}

.form-control,
input {
    color: #001216;
}
</style>
